<template>



    <div class="card-box">
        <div class="title">
            <h3>Import Enquiries</h3>
        </div>
        <div class="body">
            <el-select v-model="form.service" class="m-2" placeholder="Select" size="large">
                <el-option
                    v-for="item in services"
                    :key="item"
                    :label="item"
                    :value="item"
                />
            </el-select>
            <el-select v-model="form.source" class="m-2" placeholder="Select" size="large">
                <el-option
                    v-for="item in sources"
                    :key="item"
                    :label="item"
                    :value="item"
                />
            </el-select>
            <el-upload
                class="upload-demo"
                drag
                :action="'/enquiry-import?service='+form.service"
                :before-upload="beforeFileUpload"
                :on-error="onError"
                :headers="{ 'X-CSRF-TOKEN': csrf_token}"
                multiple
            >
                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">
                    Drop file here or <em>click to upload</em>
                </div>
                <template #tip>
                    <div class="el-upload__tip">
                        csv/xls files
                    </div>
                </template>
            </el-upload>
        </div>


    </div>

</template>

<script>
import {
    ElIcon,ElSelect,ElUpload,ElMessage,ElOption
} from 'element-plus'
import { UploadFilled } from '@element-plus/icons-vue'


import 'element-plus/dist/index.css'
import moment from 'moment'
export default {
    name: "UploadEnquiry",
    components: {    ElIcon,ElSelect,ElUpload,UploadFilled,ElOption },

    data() {
        return {
            csrf_token:null,
            loading:false,
            services:[],
            sources:[],
            form:{
                service:'',
                source:'',
            },
            rules:{
                service: [{ required: true, trigger: 'change', message:'Required' }],

            },

        }
    },
    mounted() {
        this.getdata();
        this.csrf_token=window.csrf_token;

    },
    created(){

    },
    methods:{
        getdata(){
            this.loading=true;
            let currentObj = this;
            axios.post('/enquiry/uploadenquiry').then(function (response) {
                currentObj.services=response.data.services;
                currentObj.sources=response.data.sources;
                currentObj.loading=false;
            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        beforeFileUpload(rawFile){

            if (rawFile.type !== 'application/vnd.ms-excel' && rawFile.type !== 'text/csv' && rawFile.type!=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                ElMessage.error('File must be Excel Fromat!')
                return false
            } else if (this.form.service==="") {
                ElMessage.error('Select the Leads Service')
                return false
            }
            else if (this.form.source==="") {
                ElMessage.error('Select the Leads Source')
                return false
            }
            return true
        },
        onError(error,file){
            ElMessage({
                message:'Failed '+file.name,
                type: 'error',
                duration:0,
                showClose:true
            })
        }


    }
}
</script>

<style scoped>

</style>
